import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-admin-appointments',
    templateUrl: './admin-appointments.component.html',
    styleUrl: './admin-appointments.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AdminAppointmentsComponent {

}
